<template>
  <el-dialog title="预约任务列表" :visible.sync="dialogVisible" width="60%">
    <!-- 搜索框和查询按钮 -->
    <div class="search-container">
      <el-input
        v-model="searchTaskName"
        placeholder="请输入任务名称进行模糊查询"
        clearable
        style="width: 300px; margin-right: 10px;"
        size="medium"
        @keyup.enter="handleSearch"
      >
        <i slot="prefix" class="el-icon-search el-input__icon"></i>
      </el-input>
      <el-button
        type="primary"
        icon="el-icon-search"
        size="medium"
        @click="handleSearch"
      >
        查询
      </el-button>
      <el-button
        type="default"
        icon="el-icon-refresh"
        size="medium"
        @click="handleReset"
        style="margin-left: 5px;"
      >
        重置
      </el-button>
    </div>

    <!-- 任务列表表格 -->
    <el-table :data="reservationList" border style="margin-top: 15px;">
      <el-table-column prop="taskName" label="任务名称"></el-table-column>
      <el-table-column prop="executeTime" label="执行时间"></el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 0" type="info">待执行</el-tag>
          <el-tag v-if="scope.row.status === 1" type="warning">执行中</el-tag>
          <el-tag v-if="scope.row.status === 2" type="success">成功</el-tag>
          <el-tag v-if="scope.row.status === 3" type="danger">失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260">
        <template slot-scope="scope">
          <div style="display: flex; gap: 8px;">
            <el-button size="mini" @click="handleEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
            <el-button size="mini" @click="handleViewLog(scope.row)">日志</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="current"
      :page-sizes="[10, 20, 50]"
      :page-size="size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 15px;"
    >
    </el-pagination>

    <!-- 修改执行时间弹窗 -->
    <el-dialog title="修改执行时间" :visible.sync="editDialogVisible" width="30%" append-to-body>
      <el-form :model="editForm" ref="editForm" label-width="120px">
        <el-form-item label="执行时间">
          <el-date-picker
            v-model="editForm.executeTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
            style="width: 100%;"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="执行结束时间">
          <el-date-picker
            v-model="editForm.endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 100%;"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEdit">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 任务日志弹窗 -->
    <el-dialog title="任务日志" :visible.sync="logDialogVisible" width="50%" append-to-body>
      <el-table :data="logContent" border v-if="logContent && logContent.length > 0">
        <el-table-column prop="text" label="日志内容" width="300"></el-table-column>
        <el-table-column prop="msg" label="日志信息">
          <template slot-scope="scope">
            {{ scope.row.msg || '暂无内容' }}
          </template>
        </el-table-column>
      </el-table>
      <div v-else class="no-log">暂无日志</div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import vivoBatchEditApi from '@/api/modules/vivoBatchEditApi'
import { get, post } from '../../until/controlRequest'

export default {
  name: 'ReservationView',
  
  data() {
    return {
      dialogVisible: false,
      editDialogVisible: false,
      logDialogVisible: false,
      reservationList: [],
      current: 1,
      size: 20,
      total: 0,
      currentRow: null,
      editForm: {
        id: null,
        executeTime: '',
        endDate: ''
      },
      logContent: [],
      searchTaskName: ''  // 新增：搜索框绑定的任务名称
    }
  },
  
  methods: {
    // 打开对话框
    open() {
      this.dialogVisible = true
      this.searchTaskName = ''  // 每次打开清空搜索条件
      this.current = 1  // 重置到第一页
      this.fetchReservationList()
    },

    // 获取预约列表
    async fetchReservationList() {
      try {
        const params = {
          current: this.current,
          size: this.size,
        }
        
        // 如果有搜索条件，添加taskName参数
        if (this.searchTaskName && this.searchTaskName.trim()) {
          params.taskName = this.searchTaskName.trim()
        }
        
        const data = await get('/v1/vivo-accounts/batchReserveFastFlow/page', params)
        this.reservationList = data.records || []
        this.total = data.total || 0
      } catch (error) {
        console.error('获取预约列表失败:', error)
        this.$message.error('获取数据失败')
        this.reservationList = []
        this.total = 0
      }
    },

    // 查询按钮点击事件
    handleSearch() {
      this.current = 1  // 搜索时重置到第一页
      this.fetchReservationList()
    },

    // 重置按钮点击事件
    handleReset() {
      this.searchTaskName = ''
      this.current = 1
      this.fetchReservationList()
    },

    // 每页条数变化
    handleSizeChange(val) {
      this.size = val
      this.current = 1  // 切换每页条数时回到第一页
      this.fetchReservationList()
    },

    // 当前页变化
    handleCurrentChange(val) {
      this.current = val
      this.fetchReservationList()
    },

    // 编辑任务
    handleEdit(row) {
      this.currentRow = { ...row }
      this.editForm.id = row.id
      this.editForm.executeTime = row.executeTime
      this.editForm.endDate = row.endDate
      this.editDialogVisible = true
    },

    // 确认编辑
    async confirmEdit() {
      try {
        const res = await vivoBatchEditApi.update(this.editForm)
        if (res.data && res.data.success) {
          this.$message.success('修改成功')
          this.editDialogVisible = false
          this.fetchReservationList()
        } else {
          this.$message.error(res.data.message || '修改失败')
        }
      } catch (error) {
        console.error('修改任务失败:', error)
        this.$message.error('修改失败')
      }
    },

    // 删除任务
    handleDelete(row) {
      this.$confirm('确认删除该预约任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const res = await vivoBatchEditApi.delete(row.id)
          if (res.data && res.data.success) {
            this.$message.success('删除成功')
            this.fetchReservationList()
          } else {
            this.$message.error(res.data.message || '删除失败')
          }
        } catch (error) {
          console.error('删除任务失败:', error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        // 用户取消删除
      })
    },

    // 查看日志
    async handleViewLog(row) {
      try {
        const res = await vivoBatchEditApi.logList(row.id)
        if (res.data && res.data.success) {
          this.logContent = res.data.data || []
          this.logDialogVisible = true
        } else {
          this.$message.error(res.data.message || '获取日志失败')
        }
      } catch (error) {
        console.error('获取日志失败:', error)
        this.$message.error('获取日志失败')
      }
    }
  }
}
</script>

<style scoped>
/* 搜索框容器样式 */
.search-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px 0;
}

/* 无日志提示样式 */
.no-log {
  text-align: center;
  padding: 40px;
  color: #909399;
  font-size: 14px;
}

/* 表格样式优化 */
.el-table {
  width: 100%;
}

/* 分页样式优化 */
.el-pagination {
  text-align: right;
  margin-top: 15px;
}

/* 操作按钮容器 */
.operation-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* 弹窗footer样式 */
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/vivo/ReservationView.vue